import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import ToastList from './components/ToastList';

import { removeToast } from '../../actions/ToastActions';

const StyledToastListContainer = styled.div`
  position: fixed;
  bottom: 32px;
  left: 32px;
  z-index: 2000;
  width: 50%;
  max-width: 460px;
`;

class ToastRootContainer extends Component {
  onToastClose = id => {
    this.props.removeToast(id);
  };

  onToastHover = id => {
    console.log(`Hover ${id}`);
  };

  onToastOut = id => {
    console.log(`Out ${id}`);
  };

  render() {
    const { toasts } = this.props;
    return (
      <StyledToastListContainer>
        <ToastList
          toasts={toasts.list}
          onToastClose={this.onToastClose}
          onToastHover={this.onToastHover}
          onToastOut={this.onToastOut}
        />
      </StyledToastListContainer>
    );
  }
}

const mapDispatchToProps = {
  removeToast,
};

const mapStateToProps = state => ({
  toasts: state.toasts,
});

export default connect(mapStateToProps, mapDispatchToProps)(ToastRootContainer);
